import type { Component } from 'vue'

export type SocialItem = {
  /** UUID string — the underlying `v_user_profiles.id` is a `binary(16)`, never a number. */
  id: string
  identifier: string
  followers: number | null
  icon: Component
  link: string
  title: string
  isConnected: boolean
  type: SocialItemEnum
  createdAt: string
  updatedAt: string
  isPrimary: boolean
  profileId: string | null
}

export type SlugPattern = {
  match: RegExp
  isSlugPattern: boolean
  pattern: string
  prepareSlug?: (slug: string) => string
}

type SocialObject = {
  title: string
  value: string
  icon: Component
  validatePatterns: ({ match: RegExp } | SlugPattern)[]
}

export type SocialNetworks = Record<SocialItemEnum, SocialObject>

export enum SocialItemEnum {
  Discord = 'discord',
  Facebook = 'facebook',
  Instagram = 'instagram',
  Linkedin = 'linkedin',
  Patreon = 'patreon',
  Pinterest = 'pinterest',
  Snapchat = 'snapchat',
  Telegram = 'telegram',
  TikTok = 'tiktok',
  Tumblr = 'tumblr',
  Twitter = 'twitter',
  Vimeo = 'vimeo',
  Website = 'website',
  Whatsapp = 'whatsapp',
  YouTube = 'youtube',
  Zezam = 'zezam',
}

export type MyPageLink = {
  slug: string
  url: string
}

export type SocialItemServer = {
  id: string
  type: SocialItemEnum
  identifier: string
  created_at: string
  updated_at: string
  followers: number | null
  state?: 'connected' | 'claimed' | 'verified'
  is_primary: boolean
  profile_id: string | null
}
